import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]


export const asyncRouterMap = [
  {
    path: '/report',
    component: Layout,
    name: 'report',
    meta: {title: '数据报表', icon: 'order'},
    children: [
      {
        path: 'newV2',
        name: 'newV2',
        component: () => import('@/views/report/newV2/index'),
        meta: {title: '新增活跃', icon: 'product-list'}
      },
      {
        path: 'retain',
        name: 'retain',
        component: () => import('@/views/report/retain/index'),
        meta: {title: '付费留存表', icon: 'product-list'}
      },
      {
        path: 'kernelV2',
        name: 'kernelV2',
        component: () => import('@/views/report/userKernelV2/index'),
        meta: {title: '核心数据', icon: 'product-list'}
      },
      {
        path: 'retention',
        name: 'retention',
        component: () => import('@/views/report/retention/index'),
        meta: {title: '实时留存', icon: 'product-list'}
      },
      {
        path: 'paystatistic',
        name: 'paystatistic',
        component: () => import('@/views/report/paystatistic/index'),
        meta: {title: '实时付费', icon: 'product-list'}
      },
      // {
      //   path: 'visitloginstatistic',
      //   name: 'visitloginstatistic',
      //   component: () => import('@/views/report/visitLoginStatistic/index'),
      //   meta: {title: '投放统计', icon: 'product-list'}
      // },
      {
        path: 'ltvV2',
        name: 'ltvV2',
        component: () => import('@/views/report/ltvV2/index'),
        meta: {title: '付费LTV', icon: 'product-list'}
      },
      {
        path: 'roiV2',
        name: 'roiV2',
        component: () => import('@/views/report/roiV2/index'),
        meta: {title: '付费ROI', icon: 'product-list'}
      },
      {
        path: 'adTimes',
        name: 'adTimes',
        component: () => import('@/views/report/adTimesEveryDay/index'),
        meta: {title: '广告监控', icon: 'product-list'}
      },
      {
        path: 'adClickSite',
        name: 'adClickSite',
        component: () => import('@/views/report/adClickSite/index'),
        meta: {title: '广告埋点', icon: 'product-list'}
      },
      {
        path: 'marketDataReport',
        name: 'marketDataReport',
        component: () => import('@/views/report/marketDataReport/index'),
        meta: {title: '市场报表', icon: 'product-list'}
      },
      {
        path: 'briefReport',
        name: 'briefReport',
        component: () => import('@/views/report/briefReport/index'),
        meta: {title: '数据简报', icon: 'product-list'}
      },
      {
        path: 'accumulatePay',
        name: 'accumulatePay',
        component: () => import('@/views/report/accumulatePay/index'),
        meta: {title: '累计金额', icon: 'product-list'}
      },
      {
        path: 'userRegisterPayRetain',
        name: 'userRegisterPayRetain',
        component: () => import('@/views/report/userRegisterPayRetain/index'),
        meta: {title: '注册付费留存', icon: 'product-list'}
      },
      {
        path: 'userAdRetain',
        name: 'userAdRetain',
        component: () => import('@/views/report/userAdRetain/index'),
        meta: {title: '广告用户留存', icon: 'product-list'}
      },
      {
        path: 'userNewHourStatistic',
        name: 'userNewHourStatistic',
        component: () => import('@/views/report/userNewHourStatistic/index'),
        meta: {title: '新增24小时', icon: 'product-list'}
      }
      ,
      {
        path: 'userActiveHourStatistic',
        name: 'userActiveHourStatistic',
        component: () => import('@/views/report/userActiveHourStatistic/index'),
        meta: {title: '活跃24小时', icon: 'product-list'}
      },
      {
        path: 'userOrders',
        name: 'userOrders',
        component: () => import('@/views/report/userOrders/index'),
        meta: {title: '订单明细', icon: 'product-list'}
      },
      {
        path: 'hourData',
        name: 'hourData',
        component: () => import('@/views/report/mediumHourData/index'),
        meta: {title: '媒体小时数据', icon: 'product-list'}
      },
      {
        path: 'mediumMetailReport',
        name: 'mediumMetailReport',
        component: () => import('@/views/report/mediumMetailReport/index'),
        meta: {title: '素材报表', icon: 'product-list'}
      }
      // ,
      // {
      //   path: 'broadcastAd',
      //   name: 'broadcastAd',
      //   component: () => import('@/views/report/broadcastAd/index'),
      //   meta: {title: '广告监控', icon: 'product-list'}
      // },
      // {
      //   path: 'transferRatio',
      //   name: 'transferRatio',
      //   component: () => import('@/views/report/transferRatio/index'),
      //   meta: {title: '迁移比例信息', icon: 'product-list'}
      // }
    ]
  },{
    path: '/gdt',
    component: Layout,
    name: 'gdt',
    meta: {title: '广点通', icon: 'order'},
    children: [
      {
        path: 'marketMaterial',
        name: 'marketMaterial',
        component: () => import('@/views/gdt/marketMaterial/index'),
        meta: {title: '素材库', icon: 'product-list'}
      },
      {
        path: 'addMarketMaterial',
        name: 'addMarketMaterial',
        component: () => import('@/views/gdt/marketMaterial/addOrUpdate'),
        meta: {title: '添加更新', icon: 'product-list'},
        hidden:true
      },
      {
        path: 'planTemplate',
        name: 'planTemplate',
        component: () => import('@/views/gdt/planInfoTemplate/index'),
        meta: {title: '计划模板', icon: 'product-list'}
      },{
        path: 'addPlanTemplate',
        name: 'addPlanTemplate',
        component: () => import('@/views/gdt/planInfoTemplate/addOrUpdate'),
        meta: {title: '添加/新增计划模板', icon: 'product-add'},
        hidden:true
      },{
        path: 'directionalTemplate',
        name: 'directionalTemplate',
        component: () => import('@/views/gdt/directionalTemplate/index'),
        meta: {title: '定向模板', icon: 'product-list'}
      },{
        path: 'addDirectionalTemplate',
        name: 'addDirectionalTemplate',
        component: () => import('@/views/gdt/directionalTemplate/addOrUpdate'),
        meta: {title: '添加/新增定向模板', icon: 'product-add'},
        hidden:true
      },{
        path: 'contentTemplate',
        name: 'contentTemplate',
        component: () => import('@/views/gdt/contentTemplate/index'),
        meta: {title: '文案', icon: 'product-list'}
      },{
        path: 'addContentTemplate',
        name: 'addContentTemplate',
        component: () => import('@/views/gdt/contentTemplate/addOrUpdate'),
        meta: {title: '添加/新增文案', icon: 'product-add'},
        hidden:true
      }
      ,{
        path: 'creativeTemplate',
        name: 'creativeTemplate',
        component: () => import('@/views/gdt/creativeTemplate/index'),
        meta: {title: '创意模板', icon: 'product-list'}
      }
      ,{
        path: 'planInfo',
        name: 'planInfo',
        component: () => import('@/views/gdt/planInfoDetail/index'),
        meta: {title: '广告计划', icon: 'product-list'}
      },{
        path: 'addPlanInfoTemplate',
        name: 'addPlanInfoTemplate',
        component: () => import('@/views/gdt/planInfoDetail/addOrUpdate'),
        meta: {title: '添加/新增计划', icon: 'product-add'},
        hidden:true
      },{
        path: 'addDynamic',
        name: 'addDynamic',
        component: () => import('@/views/gdt/planInfoDetail/addDynamic'),
        meta: {title: '添加/新增创意', icon: 'product-add'},
        hidden:true
      },{
        path: 'planInfoDynamic',
        name: 'planInfoDynamic',
        component: () => import('@/views/gdt/planInfoDynamic/index'),
        meta: {title: '广告创意', icon: 'product-list'}
      },
      {
        path: 'marketMaterialLableLib',
        name: 'marketMaterialLableLib',
        component: () => import('@/views/gdt/marketMetailLabelLib/index'),
        meta: {title: '媒体标签库', icon: 'product-list'}
      }
    ]
  },{
    path: '/dj',
    component: Layout,
    name: 'dj',
    meta: {title: '短剧', icon: 'order'},
    children: [
      {
        path: 'djMarketMaterial',
        name: 'djMarketMaterial',
        component: () => import('@/views/dj/marketMaterial/index'),
        meta: {title: '短剧素材库', icon: 'product-list'}
      },{
        path: 'djPlanTemplate',
        name: 'djPlanTemplate',
        component: () => import('@/views/dj/planInfoTemplate/index'),
        meta: {title: '计划模板', icon: 'product-list'}
      },{
        path: 'djDirectionalTemplate',
        name: 'djDirectionalTemplate',
        component: () => import('@/views/dj/directionalTemplate/index'),
        meta: {title: '定向模板', icon: 'product-list'}
      },{
        path: 'djContentTemplate',
        name: 'djContentTemplate',
        component: () => import('@/views/dj/contentTemplate/index'),
        meta: {title: '文案库', icon: 'product-list'}
      },{
        path: 'djPlanInfo',
        name: 'djPlanInfo',
        component: () => import('@/views/dj/planInfoDetail/index'),
        meta: {title: '广告计划', icon: 'product-list'}
      },{
        path: 'djPlanInfoDynamic',
        name: 'djPlanInfoDynamic',
        component: () => import('@/views/dj/planInfoDynamic/index'),
        meta: {title: '广告创意', icon: 'product-list'}
      }

    ]
  },{
    path: '/ad',
    component: Layout,
    name: 'ad',
    meta: {title: '广告变现', icon: 'order'},
    children: [
      {
        path: 'adEcpm',
        name: 'adEcpm',
        component: () => import('@/views/ad/adEcpm/index'),
        meta: {title: 'adEcpm维护', icon: 'product-list'}
      },{
        path: 'adLtv',
        name: 'adLtv',
        component: () => import('@/views/ad/adLtv/index'),
        meta: {title: '广告LTV', icon: 'product-list'}
      },{
        path: 'adRoi',
        name: 'adRoi',
        component: () => import('@/views/ad/adRoi/index'),
        meta: {title: '广告ROI', icon: 'product-list'}
      }
    ]
  }
  ,{
    path: '/gameGm',
    component: Layout,
    name: 'gameGm',
    meta: {title: '游戏运营', icon: 'order'},
    children: [
      {
        path: 'gameGmOperation',
        name: 'gameGmOperation',
        component: () => import('@/views/gm/gameGm/index'),
        meta: {title: 'GM管理', icon: 'product-list'}
      },
      {
        path: 'gameGmInfo',
        name: 'gameGmInfo',
        component: () => import('@/views/gm/gameInfo/index'),
        meta: {title: '信息管理', icon: 'product-list'}

      },
    ]
  }
  ,{
    path: '/reportDownload',
    component: Layout,
    name: 'reportDownload',
    meta: {title: '报表下载', icon: 'order'},
    children: [
      {
        path: 'downloadCenter',
        name: 'downloadCenter',
        component: () => import('@/views/downloadCenter/excelDownload/index'),
        meta: {title: '下载中心', icon: 'product-list'}
      }
    ]
  },{
    path: '/customerCenter',
    component: Layout,
    name: 'customerCenter',
    meta: {title: '客服管理', icon: 'order'},
    children: [
      {
        path: 'complaint',
        name: 'complaint',
        component: () => import('@/views/customerCenter/complaint/index'),
        meta: {title: '投诉中心', icon: 'product-list'}
      }
    ]
  },{
    path:'/base',
    component: Layout,
    name: 'base',
    meta: {title: '基础信息管理', icon: 'ums'},
    children: [
      {
        path: 'newGameParam',
        name: 'newGameParam',
        component: () => import('@/views/base/newGameParam/index'),
        meta: {title: '游戏管理', icon: 'product-list'}
      },
      // {
      //   path: 'addGame',
      //   name: 'addGame',
      //   component: () => import('@/views/base/game/add'),
      //   meta: {title: '添加游戏', icon: 'product-add'},
      //   hidden:true
      // },
      // {
      //   path: 'gameParam',
      //   name: 'gameParam',
      //   component: () => import('@/views/base/gameParam/index'),
      //   meta: {title: '投放渠道参数', icon: 'product-list'}
      // },
      {
        path: 'channel',
        name: 'channel',
        component: () => import('@/views/base/channel/index'),
        meta: {title: '媒介管理', icon: 'product-list'}

      },
      {
        path: 'addChannel',
        name: 'addChannel',
        component: () => import('@/views/base/channel/add'),
        meta: {title: '添加媒介', icon: 'product-add'},
        hidden:true
      },
      // {
      //   path: 'subchannel',
      //   name: 'subchannel',
      //   component: () => import('@/views/base/subchannel/index'),
      //   meta: {title: '分包管理', icon: 'product-list'}
      // },
      {
        path: 'subchannelV2',
        name: 'subchannelV2',
        component: () => import('@/views/base/subchannelV2/index'),
        meta: {title: '分链管理', icon: 'product-list'}
      },
      // {
      //   path: 'addSubChannel',
      //   name: 'addSubChannel',
      //   component: () => import('@/views/base/subchannel/add'),
      //   meta: {title: '添加分包', icon: 'product-add'},
      //   hidden:true
      // },
      {
        path: 'addSubChannelV2',
        name: 'addSubChannelV2',
        component: () => import('@/views/base/subchannelV2/add'),
        meta: {title: '添加分链', icon: 'product-add'},
        hidden:true
      },
      {
        path: 'property',
        name: 'property',
        component: () => import('@/views/base/propertyStandard/index'),
        meta: {title: '重度属性', icon: 'product-list'}
      },
      {
        path: 'addPropertyStandard',
        name: 'addPropertyStandard',
        component: () => import('@/views/base/propertyStandard/add'),
        meta: {title: '添加重度属性', icon: 'product-add'},
        hidden:true
      },
      {
        path: 'mediumTtAccount',
        name: 'mediumTtAccount',
        component: () => import('@/views/base/mediumTtAccount/index'),
        meta: {title: '媒介账户', icon: 'product-add'}
      },
      {
        path: 'mediumPlatDeveloperParam',
        name: 'mediumPlatDeveloperParam',
        component: () => import('@/views/base/mediumPlatDeveloperParam/index'),
        meta: {title: '开发者参数', icon: 'product-add'}
      },
      // {
      //   path: 'h5AccountLinking',
      //   name: 'h5AccountLinking',
      //   component: () => import('@/views/base/h5AccountLinking/index'),
      //   meta: {title: '账户信息管理', icon: 'product-add'}
      // },
      {
        path: 'gameActorInfo',
        name: 'gameActorInfo',
        component: () => import('@/views/base/gameActorInfo/index'),
        meta: {title: '角色信息查询', icon: 'product-add'}
      }
      // ,
      // {
      //   path: 'bulkTransfer',
      //   name: 'bulkTransfer',
      //   component: () => import('@/views/base/bulkTransfer/index'),
      //   meta: {title: '批量转移', icon: 'product-add'}
      // }
    ]

  },


  {
    path:'/ums',
    component: Layout,
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'allocGame',
        name: 'allocGame',
        component: () => import('@/views/ums/admin/allocGame'),
        meta: {title: '分配游戏'},
        hidden: true
      },
      {
        path: 'allocStaff',
        name: 'allocStaff',
        component: () => import('@/views/ums/admin/allocStaff'),
        meta: {title: '分配投手'},
        hidden: true
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js